export const RESET_EVERYTHING = 'RESET_EVERYTHING'

export const SET_CURRENT_SLIDE = 'SET_CURRENT_SLIDE'
export const SET_REPORT_TYPE = 'SET_REPORT_TYPE'
export const SET_COURSE_REPORT_TYPE = 'SET_COURSE_REPORT_TYPE'
export const SET_COURSE_GROUP_REPORT_TYPE = 'SET_COURSE_GROUP_REPORT_TYPE'
export const SET_ALL_COURSES = 'SET_ALL_COURSES'
export const SET_SINGLE_COURSE = 'SET_SINGLE_COURSE'
export const SET_COURSE_LOCATIONS = 'SET_COURSE_LOCATIONS'
export const SET_COURSE_LOCATION_GROUPS = 'SET_COURSE_LOCATION_GROUPS'
export const SET_SELECTED_LOCATIONS = 'SET_SELECTED_LOCATIONS'
export const RESET_SELECTED_LOCATIONS = 'RESET_SELECTED_LOCATIONS'
export const SET_COURSE_ROLES = 'SET_COURSE_ROLES'
export const SET_COURSE_ROLE_GROUPS = 'SET_COURSE_ROLE_GROUPS'
export const SET_SELECTED_ROLES = 'SET_SELECTED_ROLES'
export const RESET_SELECTED_ROLES = 'RESET_SELECTED_ROLES'
export const SET_PREVIEW_COLUMNS = 'SET_PREVIEW_COLUMNS'
export const SET_PREVIEW_ROWS = 'SET_PREVIEW_ROWS'
export const SET_POSSIBLE_COLUMNS = 'SET_POSSIBLE_COLUMNS'
export const SET_DOWNLOADING = 'SET_DOWNLOADING'
export const SET_SAVED_REPORTS = 'SET_SAVED_REPORTS'
export const SET_SAVED_REPORTS_ROWS = 'SET_SAVED_REPORTS_ROWS'
export const SET_SAVING_DOWNLOADING = 'SET_SAVING_DOWNLOADING'
export const SET_EDITING_REPORT = 'SET_EDITING_REPORT'
export const SET_FILTER_SELECTED_ONLY = 'SET_FILTER_SELECTED_ONLY'
export const SET_REPORT = 'SET_REPORT'
export const SET_DOWNLOADING_FROM_MAIN_PAGE = 'SET_DOWNLOADING_FROM_MAIN_PAGE'
export const SET_MULTIPlE_COURSES = 'SET_MULTIPlE_COURSES'
export const SET_CONTINUE_DISABLED = 'SET_CONTINUE_DISABLED'
export const SET_CONTINUE_BUTTON_TEXT = 'SET_CONTINUE_BUTTON_TEXT'
export const SET_EXACT_REPORT_TYPE = 'SET_EXACT_REPORT_TYPE'
export const SET_FINAL_SLIDE = 'SET_FINAL_SLIDE'

export const SET_SINGLE_COURSE_GROUP = 'SET_SINGLE_COURSE_GROUP'
export const SET_MULTIPLE_COURSE_GROUPS = 'SET_MULTIPLE_COURSE_GROUPS'
export const SET_ALL_COURSE_GROUPS = 'SET_ALL_COURSE_GROUPS'
export const SET_COURSE_GROUP_LOCATIONS = 'SET_COURSE_GROUP_LOCATIONS'
export const SET_COURSE_GROUP_LOCATION_GROUPS =
  'SET_COURSE_GROUP_LOCATION_GROUPS'

export const SET_COURSE_GROUP_ROLES = 'SET_COURSE_GROUP_ROLES'
export const SET_COURSE_GROUP_ROLE_GROUPS = 'SET_COURSE_GROUP_ROLE_GROUPS'
export const SET_COMPLETED_SLIDES = 'SET_COMPLETED_SLIDES'
export const SET_ADMINS = 'SET_ADMINS'
export const SET_EMAIL_REPORT = 'SET_EMAIL_REPORT'
